<template>
  <div id="container" class="menu">
    <slot hiddenCopyright></slot>
    <main>
      <h1 class="stage-name">うみ</h1>
      <MpHamburger class="hamburger"/>
      <div id="list" @click.stop="doTimesTable">
        <img class="ship" :src="$image('normal/buttons/times_tables/ship.svg')" alt="">
        <img class="button" :src="$image('normal/buttons/times_tables/button-times_tables.svg')" alt="">
      </div>
      <div class="clear-count">
        <img class="balloon" :src="balloonImage" alt="">
        <div class="message-first"><span class="number">{{ answeredCount }}</span>もん</div>
        <div class="message-second">といたよ</div>
      </div>
      <div class="toParent" @click="isShowToParent = true">
        <img :src="$image('normal/buttons/to_parent-inner.svg')" alt="">
      </div>
      <div id="stages">
        <MpStageNormal
          class="stage stage2"
          :table="sequence.table2"
          :isCleared="isTableClear('table2')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 2"
          :glow="isGlowSingleButtons"
        />
        <MpStageNormal
          class="stage stage3"
          :table="sequence.table3"
          :isCleared="isTableClear('table3')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 3"
          :glow="isGlowSingleButtons"
        />
        <MpStageNormal
          class="stage stage4"
          :table="sequence.table4"
          :isCleared="isTableClear('table4')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 4"
          :glow="isGlowSingleButtons"
        />
        <MpStageNormal
          class="stage stage5"
          :table="sequence.table5"
          :isCleared="isTableClear('table5')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 5"
          :glow="isGlowSingleButtons"
          left
        />
        <MpStageNormal
          class="stage stage6"
          :table="sequence.table6"
          :isCleared="isTableClear('table6')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 6"
          :glow="isGlowSingleButtons"
          left
        />
        <MpStageNormal
          class="stage stage7"
          :table="sequence.table7"
          :isCleared="isTableClear('table7')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 7"
          :glow="isGlowSingleButtons"
          left
        />
        <MpStageNormal
          class="stage stage8"
          :table="sequence.table8"
          :isCleared="isTableClear('table8')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 8"
          :glow="isGlowSingleButtons"
        />
        <MpStageNormal
          class="stage stage9"
          :table="sequence.table9"
          :isCleared="isTableClear('table9')"
          :isReached="!isPlayingHermitCrab && maxClearedTable === 9"
          :glow="isGlowSingleButtons"
        />

        <MpBridge
          class="bridge bridge2-3"
          bridgePath="normal/bridges/bridge-2–3-blue.svg"
          clearedBridgePath="normal/bridges/bridge-2–3-yellow.svg"
          :clearLevel="clearedContentsOf('table2')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge3-4"
          bridgePath="normal/bridges/bridge-3–4-blue.svg"
          clearedBridgePath="normal/bridges/bridge-3–4-yellow.svg"
          :clearLevel="clearedContentsOf('table3')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge4-5"
          bridgePath="normal/bridges/bridge-4–5-blue.svg"
          clearedBridgePath="normal/bridges/bridge-4–5-yellow.svg"
          :clearLevel="clearedContentsOf('table4')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge5-6"
          bridgePath="normal/bridges/bridge-5–6-blue.svg"
          clearedBridgePath="normal/bridges/bridge-5–6-yellow.svg"
          :clearLevel="clearedContentsOf('table5')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge6-7"
          bridgePath="normal/bridges/bridge-6–7-blue.svg"
          clearedBridgePath="normal/bridges/bridge-6–7-yellow.svg"
          :clearLevel="clearedContentsOf('table6')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge7-8"
          bridgePath="normal/bridges/bridge-7–8-blue.svg"
          clearedBridgePath="normal/bridges/bridge-7–8-yellow.svg"
          :clearLevel="clearedContentsOf('table7')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge8-9"
          bridgePath="normal/bridges/bridge-8–9-blue.svg"
          clearedBridgePath="normal/bridges/bridge-8–9-yellow.svg"
          :clearLevel="clearedContentsOf('table8')"
          :glow="isGlowBridges"
        />
        <MpBridge
          class="bridge bridge9-0"
          bridgePath="normal/bridges/bridge-9–0-blue.svg"
          clearedBridgePath="normal/bridges/bridge-9–0-yellow.svg"
          :clearLevel="clearedContentsOf('table9')"
          :glow="isGlowBridges"
        />
        <MpHermitCrab
          v-show="isPlayingHermitCrab"
          ref="hermitCrab"
          :from="oldMaxClearedTable"
          :to="maxClearedTable"
        />

        <MpStageNormal
          class="stage stage2-3"
          :table="sequence.table2to3"
          :clearedPremise="isTableClear('table3')"
          :isCleared="isTableClear('table2to3')"
          coral="normal/buttons/times_table-2–3/melithaea-yellow.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-4"
          :table="sequence.table2to4"
          :clearedPremise="isTableClear('table4')"
          :isCleared="isTableClear('table2to4')"
          coral="normal/buttons/times_table-2–4/coral_reef-blue.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-5"
          :table="sequence.table2to5"
          :clearedPremise="isTableClear('table5')"
          :isCleared="isTableClear('table2to5')"
          coral="normal/buttons/times_table-2–5/melithaea-red.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-6"
          :table="sequence.table2to6"
          :clearedPremise="isTableClear('table6')"
          :isCleared="isTableClear('table2to6')"
          coral="normal/buttons/times_table-2–6/cauliflower_coral-blue.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-7"
          :table="sequence.table2to7"
          :clearedPremise="isTableClear('table7')"
          :isCleared="isTableClear('table2to7')"
          coral="normal/buttons/times_table-2–7/cauliflower_coral-pink.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-8"
          :table="sequence.table2to8"
          :clearedPremise="isTableClear('table8')"
          :isCleared="isTableClear('table2to8')"
          coral="normal/buttons/times_table-2–8/melithaea-green.svg"
          :glow="isGlowMultiButtons"
        />
        <MpStageNormal
          class="stage stage2-9"
          :table="sequence.table2to9"
          :clearedPremise="isTableClear('table9')"
          :isCleared="isTableClear('table2to9')"
          coral="normal/buttons/times_table-2–9/coral_reef-pink.svg"
          :glow="isGlowMultiButtons"
        />
        <div class="stage go-bonus" @click="doBonus()">
          <img class="shadow" :src="$image('normal/buttons/decoration/island-large-shadow.svg')" alt="">
          <img class="image" :src="$image(`normal/buttons/decoration/island-large.svg`)">
          <template v-if="isPlayingAnimation || !isNormalStageCompleted">
            <MpHermitCrab
              v-show="!isPlayingHermitCrab && isNormalSingleCompleted"
              class="hermit_crab-a"
              type="a"
            />
            <MpHermitCrab class="hermit_crab-b" type="b" />
          </template>
          <img v-if="!isPlayingAnimation && isNormalStageCompleted" :class="['rocket ready', { glow: isGlowRocket }]" :src="$image('normal/buttons/decoration/rocket-ready.svg')">
          <img v-else-if="isNormalMultiCompleted" class="rocket" :src="$image('normal/buttons/decoration/rocket-active.svg')">
          <img v-else  class="rocket" :src="$image('normal/buttons/decoration/rocket-inactive.svg')">
          <img
            class="button"
            :src="$image(`normal/buttons/go_bonus-${(isNormalMultiCompleted) ? 'active' : 'inactive'}.svg`)"
            alt=""
          />
          <img class="check" v-if="isBonusStageCompleted" :src="$image('normal/buttons/decoration/checkmark-red.svg')">
        </div>
      </div>
      <template v-if="!isOnIntroduction">
        <MpEffectGetItem name="table2to3-level1">
          <MpAnimation v-if="clearedContentsOf('table2to3') >= 1" class="illust-clear illust-clear1">
            <img :src="$image(`${illustPath}/octopus.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to3-level2">
          <MpAnimation v-if="clearedContentsOf('table2to3') >= 2" class="illust-clear illust-clear2"  :delay="0.1">
            <img :src="$image(`${illustPath}/clownfish.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to4-level1">
          <MpAnimation v-if="clearedContentsOf('table2to4') >= 1" class="illust-clear illust-clear3" type="float"  :delay="0.2">
            <img :src="$image(`${illustPath}/turtle.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to4-level2">
          <MpAnimation v-if="clearedContentsOf('table2to4') >= 2" class="illust-clear illust-clear4"  :delay="0.3">
            <img :src="$image(`${illustPath}/sunfish.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to5-level1">
          <MpAnimation v-if="clearedContentsOf('table2to5') >= 1" class="illust-clear illust-clear5" :delay="0.4">
            <img :src="$image(`${illustPath}/crab.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to5-level2">
          <MpAnimation v-if="clearedContentsOf('table2to5') >= 2" class="illust-clear illust-clear6" :delay="0.5">
            <img :src="$image(`${illustPath}/moorish_idol.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to6-level1">
          <MpAnimation v-if="clearedContentsOf('table2to6') >= 1" class="illust-clear illust-clear7" type="float"  :delay="0.6">
            <img :src="$image(`${illustPath}/seahorse.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to6-level2">
          <MpAnimation v-if="clearedContentsOf('table2to6') >= 2" class="illust-clear illust-clear8" :delay="0.7">
            <img :src="$image(`${illustPath}/manta_ray.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to7-level1">
          <MpAnimation v-if="clearedContentsOf('table2to7') >= 1" class="illust-clear illust-clear9" type="swing" :delay="0.8">
            <img :src="$image(`${illustPath}/dolphin.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to7-level2">
          <MpAnimation v-if="clearedContentsOf('table2to7') >= 2" class="illust-clear illust-clear10" :delay="0.9">
            <img :src="$image(`${illustPath}/spotted_garden_eel.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to8-level1">
          <MpAnimation v-if="clearedContentsOf('table2to8') >= 1" class="illust-clear illust-clear11" type="float" :delay="1">
            <img :src="$image(`${illustPath}/pufferfish.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to8-level2">
          <MpAnimation v-if="clearedContentsOf('table2to8') >= 2" class="illust-clear illust-clear12" :delay="1.1">
            <img :src="$image(`${illustPath}/surgeonfish.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to9-level1">
          <MpAnimation v-if="clearedContentsOf('table2to9') >= 1" class="illust-clear illust-clear13" type="float" :delay="1.2">
            <img :src="$image(`${illustPath}/whale_shark.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
        <MpEffectGetItem name="table2to9-level2">
          <MpAnimation v-if="clearedContentsOf('table2to9') >= 2" class="illust-clear illust-clear14" :delay="1.3">
            <img :src="$image(`${illustPath}/sea_otter.svg`)" alt="">
          </MpAnimation>
        </MpEffectGetItem>
      </template>

      <MpSpeechBubble
        v-if="isShowSpeechBubbleOnCompleteMulti"
        class="speech_bubble7"
        @close="isShowSpeechBubbleOnCompleteMulti = false"
        arrowDirection="bottom right"
        arrowPos="60%"
      >
        いっしょに うちゅうにいこう！
      </MpSpeechBubble>

      <MpBackgroundWaves />

      <MpAppIntroduction v-if="shouldPlayIntroduction" @finished="shouldPlayIntroduction = false" />
      <MpPopup v-if="isShowTapPrompt" :overlayStyle="{ 'background-color': 'rgba(256, 256, 256, 0.5)' }" @close="closeTapPrompt()">
        <img class="popup-tap_prompt" :src="$image('hajimeru.svg')" width="300" height="104" alt="九九のぼうけんをはじめる" />
        <img class="popup-tap_prompt-finger" :src="$image('finger.svg')" alt="" />
      </MpPopup>
    </main>
    <footer>
      <MpCopyright rigid></MpCopyright>
    </footer>
    <div v-if="isShowToParent" class="modal-to_parent">
      <img class="image" :src="$image('normal/to_parent.png')" alt="">
      <img class="close" :src="$image('menu_close.svg')" alt="メニューを閉じる" @click="isShowToParent = false" />
      <MpCopyright class="copyright" rigid />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import gsap from "gsap";

import MpAppIntroduction from "@/components/ui/MpAppIntroduction.vue";
import MpHamburger from "@/components/ui/MpHamburger";
import MpStageNormal from "@/components/ui/MpStageNormal";
import MpBridge from "@/components/ui/MpBridge";
import Normal from "@/mixins/normal";
import MpCopyright from "@/components/ui/MpCopyright.vue";
import MpEffectGetItem from "../../ui/MpEffectGetItem.vue";
import MpHermitCrab from "../../ui/MpHermitCrab.vue";
import MpSpeechBubble from "../../ui/MpSpeechBubble.vue";
import MpBackgroundWaves from "../../ui/MpBackgroundWaves.vue";
import MpAnimation from "../../ui/MpAnimation.vue";
import MpPopup from "../../ui/MpPopup.vue";

export default {
  components: {
    MpAppIntroduction,
    MpHamburger,
    MpStageNormal,
    MpBridge,
    MpCopyright,
    MpEffectGetItem,
    MpHermitCrab,
    MpSpeechBubble,
    MpBackgroundWaves,
    MpAnimation,
    MpPopup,
  },
  mixins: [Normal],
  data() {
    return {
      oldMaxClearedTable: this.$store.state.learningState.maxClearedTable,
      isShowToParent: false,
      isShowSpeechBubbleOnCompleteMulti: false,
      shouldPlayIntroduction: false,
      isGlowBridges: false,
      isGlowSingleButtons: false,
      isGlowMultiButtons: false,
      isGlowRocket: false,
    };
  },
  computed: {
    ...mapState({
      isOnIntroduction: (state) => state.app.isOnIntroduction,
      introductionStep: (state) => state.app.introductionStep,
    }),
    illustPath() {
      return "normal/illusts";
    },
    answeredCount() {
      const answered = this.$store.getters["learningState/getAnswered"];
      const max = 9999;

      if (answered > max) {
        return max;
      }

      return answered;
    },
    balloonImage() {
      let balloon = "balloon-blue";

      if (this.answeredCount < 200) {
        balloon = "balloon-blue";
      } else if (this.answeredCount < 400) {
        balloon = "balloon-green";
      } else if (this.answeredCount < 600) {
        balloon = "balloon-orange";
      } else if (this.answeredCount < 800) {
        balloon = "balloon-pink";
      } else {
        balloon = "balloon-rainbow";
      }

      return this.$image(`${this.illustPath}/${balloon}.svg`)
    },
    isNormalStageCompleted() {
      return this.$store.getters["learningState/isNormalContentCompleted"];
    },
    isNormalSingleCompleted() {
      return this.$store.getters["learningState/isNormalSingleContentCompleted"];
    },
    isNormalMultiCompleted() {
      return this.$store.getters["learningState/isNormalMultiContentCompleted"];
    },
    isBonusStageCompleted() {
      return this.$store.getters["learningState/isBonusContentCompleted"];
    },
    maxClearedTable() {
      if (this.isOnIntroduction && [2, 3, 4].includes(this.introductionStep)) {
        return 10;
      }

      for (let table = 2; table <= 9; table++) {
        if (!this.isTableClear(`table${table}`)) {
          return table;
        }
      }

      return 10;
    },
    isNormalStageClearOld() {
      return this.$store.getters["learningState/getIsNormalStageClear"];
    },
    isPlayingHermitCrab() {
      return this.$store.state.animation.currentPlaying === "CrossBridgeHermitCrabA" ||
        this.$store.state.animation.queue.some((item) => item.key === "CrossBridgeHermitCrabA");
    },
    isPlayingHermitCrabJump() {
      return this.$store.state.animation.currentPlaying === "reachLastIsland";
    },
    isPlayingRocket() {
      return this.$store.state.animation.currentPlaying === "gettingOnRocket";
    },
    isPlayingAnimation() {
      return this.$store.state.animation.currentPlaying !== "";
    },
    isShowTapPrompt() {
      return this.$store.getters["app/getIsShowTapPrompt"];
    },
  },
  created() {
    // 横レイアウト強制
    this.$log.debug("横レイアウト強制");
    this.$store.commit("app/enforceOrientationLandscape");
  },
  mounted() {
    this.$eventBus.$on("on-bridge-glow", () => {
      this.isGlowBridges = true;
    });
    this.$eventBus.$on("off-bridge-glow", () => {
      this.isGlowBridges = false;
    });
    this.$eventBus.$on("on-single_button-glow", () => {
      this.isGlowSingleButtons = true;
    });
    this.$eventBus.$on("off-single_button-glow", () => {
      this.isGlowSingleButtons = false;
    });
    this.$eventBus.$on("on-multi_button-glow", () => {
      this.isGlowMultiButtons = true;
    });
    this.$eventBus.$on("off-multi_button-glow", () => {
      this.isGlowMultiButtons = false;
    });
    this.$eventBus.$on("on-rocket-glow", () => {
      this.isGlowRocket = true;
    });
    this.$eventBus.$on("off-rocket-glow", () => {
      this.isGlowRocket = false;
    });

    // ノーマルステージ選択
    this.$store.dispatch("app/selectStage", "normal");

    const isFromLogin = this.$store.getters["app/getPrevView"] === "ViewLoading";
    const isNotClearedAnyContents = this.$store.getters["learningState/isNotClearedAnyContent"];

    this.shouldPlayIntroduction = isFromLogin && isNotClearedAnyContents;

    if (this.oldMaxClearedTable < this.maxClearedTable) {
      this.$store.commit("animation/addToQueue", {
        key: "CrossBridgeHermitCrabA",
      });

      if (this.maxClearedTable === 10) {
        this.$store.commit("animation/addToQueue", {
          key: "reachLastIsland",
        });
      }
    }

    this.$store.commit("learningState/setMaxClearedTable", this.maxClearedTable);

    if (this.isNormalStageCompleted && !this.isNormalStageClearOld) {
      this.$store.commit("animation/addToQueue", {
        key: "gettingOnRocket",
      });
      this.$store.commit("learningState/setIsNormalStageClear", this.isNormalStageCompleted);
    }

    this.$store.dispatch("animation/startPlaying");
  },
  beforeDestroy() {
    this.$store.commit("animation/clear");

    this.$eventBus.$off("on-bridge-glow");
    this.$eventBus.$off("off-bridge-glow");
    this.$eventBus.$off("on-single_button-glow");
    this.$eventBus.$off("off-single_button-glow");
    this.$eventBus.$off("on-multi_button-glow");
    this.$eventBus.$off("off-multi_button-glow");
    this.$eventBus.$off("on-rocket-glow");
    this.$eventBus.$off("off-rocket-glow");
  },
  watch: {
    async "$store.state.animation.currentPlaying"(playing) {
      await this.$nextTick();
      if (playing === "gettingOnRocket") {
        const tl = gsap.timeline({
          onStart:() => {
            this.isShowSpeechBubbleOnCompleteMulti = true;
            this.$sound.multiClear().play();
          },
          onComplete: () => {
            this.$store.dispatch("animation/next", "gettingOnRocket");
          },
        });

        tl.to(".hermit_crab-a", {
          duration: 1.5,
          top: "-119%",
          left: "30%",
          scale: 0.5,
          ease: "power1.inOut",
          onPlay: () => {
            this.$sound.allDone().play();
          },
        });

        tl.to(".hermit_crab-b", {
          duration: 1.5,
          top: "-82%",
          left: "29%",
          scale: 0.5,
          ease: "power1.inOut",
          delay: 0.5,
          onPlay: () => {
            this.$sound.goSpaceTogether().play();
          },
        });
      }
    },
  },
  methods: {
    // 九九いちらん表示
    doTimesTable() {
      // 画面ボタン操作イベント
      this.$store.dispatch("history/viewButtonEvent", {
        loginId: this.$store.getters["auth/getLoginId"],
        view: this.$store.getters["app/getCurrentView"],
        event: "九九いちらん表示",
      });
      // 画面遷移
      this.$store.commit("app/setCurrentView", "ViewTimesTable");
    },
    // ボーナスステージ表示
    doBonus() {
      // 画面ボタン操作イベント
      this.$store.dispatch("history/viewButtonEvent", {
        loginId: this.$store.getters["auth/getLoginId"],
        view: this.$store.getters["app/getCurrentView"],
        event: "うちゅう選択",
      });
      // 画面遷移
      if (this.isNormalStageCompleted) {
        this.$store.commit("app/setCurrentView", "ViewStageGoBonusAnimation");
      } else {
        this.$store.commit("app/setCurrentView", "ViewStageBonus");
      }
    },
    clearedContentsOf(table) {
      return this.$store.getters["learningState/countTableClearedContets"](
        "normal",
        table,
      );
    },
    closeTapPrompt() {
      this.$store.commit("app/setIsShowTapPrompt", false);
    },
  },
};
</script>

<style lang="scss" scoped>
#container {
  main {
    position: relative;
    background: var(--bg-image-bg_normal) no-repeat center / contain;

    .stage-name {
      position: absolute;
      top: 0;
      padding-top: 1.5%;
      width: 100%;
      padding-left: 1.5%;
    }

    #list {
      position: absolute;
      bottom: 2%;
      left: 1.6%;

      .ship {
        width: calc(var(--size-base) * 131.67);
        position: absolute;
        bottom: 92%;
        left: 19%;
        z-index: 0;
      }

      .button {
        position: relative;
        width: calc(var(--size-base) * 214.17);
        z-index: 10;
      }
    }

    .hamburger {
      position: absolute !important;
      top: 1%;
      right: 1.5%;
      z-index: var(--z-index-screen-button);
    }

    .clear-count {
      position: absolute;
      top: 1%;
      left: 10.52%;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 50%;
      color: #FFFFFF;

      img {
        position: absolute;
        width: calc(var(--size-base) * 130);
        z-index: 0;
      }

      div {
        font-weight: bold;
        font-size: 1.2rem;
        z-index: 1;

        &.message-first {
          margin-top: 1.1rem;

          .number {
            font-size: 1.5rem;
          }
        }
        &.message-second {
          margin-top: 0.1rem;
        }
      }
    }

    .toParent {
      @extend %btn-default;

      background-color: #BAE3F9;
      border-color: #3A82C5;
      box-shadow: 0 calc(var(--size-base)*3) 0 #3A82C5;

      position: absolute;
      top: 1%;
      right: 6%;
      padding: 0.3% 0.75%;
      z-index: var(--z-index-screen);

      width: calc(var(--size-base) * 162.98);

      &>img {
        width: 100%;
      }
    }

    #stages {
      position: relative;
      width: 100%;
      height: 100%;
      margin-top: 2.2%;

      .stage {
        position: absolute;
      }

      .stage2 {
        top: 39.4%;
        left: 2%;
      }
      .stage3 {
        top: 19.9%;
        left: 26.3%;
      }
      .stage4 {
        top: 16.27%;
        left: 58.4%;
      }
      .stage5 {
        top: 35.4%;
        left: 85.9%;
      }
      .stage6 {
        top: 54.08%;
        left: 61.64%;
      }
      .stage7 {
        top: 46.67%;
        left: 36.3%;
      }
      .stage8 {
        top: 69.4%;
        left: 16%;
      }
      .stage9 {
        top: 84.6%;
        left: 43.6%;
      }

      .stage2-3 {
        top: 8.3%;
        left: 42.6%;
      }
      .stage2-4 {
        top: 13.3%;
        left: 75.52%;
      }
      .stage2-5 {
        top: 54.35%;
        left: 75.52%;
      }
      .stage2-6 {
        top: 34.2%;
        left: 50.31%;
      }
      .stage2-7 {
        top: 39.4%;
        left: 23.6%;
      }
      .stage2-8 {
        top: 65%;
        left: 31.4%;
      }
      .stage2-9 {
        top: 74%;
        left: 59.1%;
      }

      .go-bonus {
        cursor: pointer;
        position: absolute;
        bottom: 6.8%;
        right: 1.4%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .shadow {
          position: absolute;
          width: calc(var(--size-base) * 323.52);
          right: -2.1%;
          bottom: -9%;
        }

        .hermit_crab-a {
          position: absolute;
          width: calc(var(--size-base) * 71.48);
          right: 119%;
          bottom: 107%;
          z-index: var(--z-index-stage-illust-front);
        }

        .hermit_crab-b {
          position: absolute;
          width: calc(var(--size-base) * 71.48);
          right: 79%;
          bottom: 107%;
          z-index: var(--z-index-stage-illust-front);
        }

        .rocket {
          position: absolute;
          width: calc(var(--size-base) * 75.55);
          bottom: 106%;
          right: 31%;
          z-index: var(--z-index-stage-illust-back);

          &.ready {
            width: calc(var(--size-base) * 93.55);
          }

          transition: filter 0.3s;
          filter: drop-shadow(0px 0px calc(var(--size-base) * 10) transparent);

          &.glow {
            filter: drop-shadow(0px 0px calc(var(--size-base) * 10) #ff0000);
          }
        }

        .image {
          width: calc(var(--size-base) * 315);
          position: absolute;
          bottom: -3%;
          right: 1%;
          z-index: 10;
        }

        .button {
          width: calc(var(--size-base) * 190);
          z-index: 20;
        }

        .check {
          position: absolute;
          width: calc(var(--size-base) * 36.18);
          top: -12%;
          right: 0.4%;
          z-index: 30;
        }
      }
    }

    .bridge {
      position: absolute;

      &.bridge2-3 {
        top: 16.5%;
        left: 8.5%;

        ::v-deep .line {
          width: calc(var(--size-base) * 323.52);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 52.2%;
            left: 23.3%;
          }
          &.dot2 {
            top: 43%;
            left: 29.8%;
          }
          &.dot3 {
            top: 34.4%;
            left: 37.2%;
          }
          &.dot4 {
            top: 27.5%;
            left: 44.8%;
          }
          &.dot5 {
            top: 20.8%;
            left: 52.7%;
          }
          &.dot6 {
            top: 15.9%;
            left: 60.9%;
          }
        }
      }
      &.bridge3-4 {
        top: -6%;
        left: 35.6%;

        ::v-deep .line {
          width: calc(var(--size-base) * 342);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 59.7%;
            left: 28.2%;
          }
          &.dot2 {
            top: 60.8%;
            left: 34.9%;
          }
          &.dot3 {
            top: 61.1%;
            left: 42%;
          }
          &.dot4 {
            top: 60.9%;
            left: 48.8%;
          }
          &.dot5 {
            top: 60%;
            left: 55.7%;
          }
          &.dot6 {
            top: 58.7%;
            left: 62.7%;
          }
        }
      }
      &.bridge4-5 {
        top: -0.3%;
        left: 67.7%;

        ::v-deep .line {
          width: calc(var(--size-base) * 295);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 51%;
            left: 24%;
          }
          &.dot2 {
            top: 54.8%;
            left: 31.1%;
          }
          &.dot3 {
            top: 57.7%;
            left: 38.7%;
          }
          &.dot4 {
            top: 60%;
            left: 46.4%;
          }
          &.dot5 {
            top: 61.6%;
            left: 54.5%;
          }
          &.dot6 {
            top: 62.3%;
            left: 62.5%;
          }
        }
      }
      &.bridge5-6 {
        top: 28%;
        left: 69%;

        ::v-deep .line {
          width: calc(var(--size-base) * 277);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 43.3%;
            left: 68.2%;
          }
          &.dot2 {
            top: 52.8%;
            left: 60.9%;
          }
          &.dot3 {
            top: 60.3%;
            left: 53.1%;
          }
          &.dot4 {
            top: 66.2%;
            left: 44.8%;
          }
          &.dot5 {
            top: 71.1%;
            left: 36.5%;
          }
          &.dot6 {
            top: 75.2%;
            left: 27.8%;
          }
        }
      }
      &.bridge6-7 {
        top: 29.16%;
        left: 46%;

        ::v-deep .line {
          width: calc(var(--size-base) * 261);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 56.19%;
            left: 65.41%;
          }
          &.dot2 {
            top: 56.5%;
            left: 56.3%;
          }
          &.dot3 {
            top: 55.7%;
            left: 47.3%;
          }
          &.dot4 {
            top: 54.2%;
            left: 38.4%;
          }
          &.dot5 {
            top: 52.2%;
            left: 29.3%;
          }
          &.dot6 {
            top: 49.3%;
            left: 20.7%;
          }
        }
      }
      &.bridge7-8 {
        top: 42.2%;
        left: 21.22%;

        ::v-deep .line {
          width: calc(var(--size-base) * 256);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 32.5%;
            left: 71%;
          }
          &.dot2 {
            top: 42.6%;
            left: 63.9%;
          }
          &.dot3 {
            top: 51.4%;
            left: 56.5%;
          }
          &.dot4 {
            top: 59.5%;
            left: 48.7%;
          }
          &.dot5 {
            top: 66.5%;
            left: 40.5%;
          }
          &.dot6 {
            top: 72.3%;
            left: 32.1%;
          }
        }
      }
      &.bridge8-9 {
        top: 51.5%;
        left: 24.1%;

        ::v-deep .line {
          width: calc(var(--size-base) * 307);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 53.1%;
            left: 28.68%;
          }
          &.dot2 {
            top: 56.6%;
            left: 35.6%;
          }
          &.dot3 {
            top: 59.1%;
            left: 42.8%;
          }
          &.dot4 {
            top: 61.2%;
            left: 50.1%;
          }
          &.dot5 {
            top: 63%;
            left: 57.8%;
          }
          &.dot6 {
            top: 63.8%;
            left: 65.4%;
          }
        }
      }
      &.bridge9-0 {
        top: 60.5%;
        left: 52.8%;

        ::v-deep .line {
          width: calc(var(--size-base) * 323);
        }

        ::v-deep .dot {
          &.dot1 {
            top: 59.15%;
            left: 28.6%;
          }
          &.dot2 {
            top: 60.4%;
            left: 35.8%;
          }
          &.dot3 {
            top: 60.7%;
            left: 43.2%;
          }
          &.dot4 {
            top: 60.7%;
            left: 50.6%;
          }
          &.dot5 {
            top: 60.1%;
            left: 57.8%;
          }
          &.dot6 {
            top: 58.5%;
            left: 65.1%;
          }
        }
      }
    }

    .illust-clear {
      position: absolute;
      z-index: var(--z-index-bg-illust);

      &>img {
        width: 100%;
      }
    }

    .illust-clear1 {
      width: calc(var(--size-base) * 70.61);
      top: 58.65%;
      left: 47.32%;
    }
    .illust-clear2 {
      width: calc(var(--size-base) * 76.82);
      top: 3.78%;
      left: 21.88%;
      transform: scale(-1, 1) rotate(14.5deg);
    }
    .illust-clear3 {
      transform: scale(-1, 1) rotate(-21deg);
      width: calc(var(--size-base) * 70);
      top: 54.7%;
      left: 1.88%;
    }
    .illust-clear4 {
      width: calc(var(--size-base) * 59.61);
      top: 49.7%;
      left: 88.4%;
    }
    .illust-clear5 {
      transform: scale(-1, 1) rotate(-12deg);
      width: calc(var(--size-base) * 73.43);
      top: 11.6%;
      left: 88.3%;
    }
    .illust-clear6 {
      width: calc(var(--size-base) * 78.02);
      top: 58%;
      left: 8.72%;
    }
    .illust-clear7 {
      transform: rotate(-7deg);
      width: calc(var(--size-base) * 42.71);
      top: 33.7%;
      left: 75.25%;
    }
    .illust-clear8 {
      transform: rotate(42deg);
      width: calc(var(--size-base) * 69.63);
      top: 65.5%;
      left: 54.95%;
    }
    .illust-clear9 {
      width: calc(var(--size-base) * 84.25);
      top: 16.4%;
      left: 17.2%;
    }
    .illust-clear10 {
      width: calc(var(--size-base) * 66.41);
      top: 84.7%;
      left: 26.2%;
    }
    .illust-clear11 {
      width: calc(var(--size-base) * 67.39);
      top: 3%;
      left: 39%;
    }
    .illust-clear12 {
      width: calc(var(--size-base) * 68.78);
      top: 17.7%;
      left: 1.6%;
    }
    .illust-clear13 {
      width: calc(var(--size-base) * 75.95);
      top: 38.4%;
      left: 17%;
    }
    .illust-clear14 {
      width: calc(var(--size-base) * 84.89);
      top: 60.5%;
      left: 92%;
    }
  }

  footer {
    padding-left: 1.3%;
    background-color: #FFFFFF;
    height: 4.5%;
  }
}

.stage2-3 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 67%;
      top: -7%;
      left: -9%;
    }

    .step2 {
      width: 64%;
      top: 25.7%;
      left: 47.6%;
    }
  }
}

.stage2-4 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 76%;
      top: -4.8%;
      left: -10%;
    }

    .step2 {
      width: 54%;
      top: 21%;
      left: 49%;
    }
  }
}

.stage2-5 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 70%;
      top: -7%;
      left: 14%;
    }

    .step2 {
      width: 60%;
      top: 45%;
      left: 69%;
    }
  }
}

.stage2-6 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 62%;
      top: -4%;
      left: -7%;
    }

    .step2 {
      width: 66%;
      top: 47%;
      left: 42%;
    }
  }
}

.stage2-7 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 73%;
      top: -16%;
      left: -15%;
    }

    .step2 {
      width: 59%;
      top: 35%;
      left: 54%;
    }
  }
}

.stage2-8 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 60%;
      top: 2%;
      left: 5%;
    }

    .step2 {
      width: 58%;
      top: 29%;
      left: 60%;
    }
  }
}

.stage2-9 {
  ::v-deep .level-clear-progress {
    .step1 {
      width: 49%;
      top: -22%;
      left: 40%;
    }

    .step2 {
      width: 67%;
      top: 20%;
      left: 5%;
    }
  }
}

.modal-to_parent {
  position: fixed;
  width: var(--app-width);
  min-width: var(--app-width);
  height: var(--app-height);
  min-height: var(--app-height);
  background-color: #FFFFFF;
  z-index: var(--z-index-screen-popup);

  .image {
    width: 100%;
  }

  .close {
    position: absolute;
    top: 1%;
    right: 3%;
    width: calc(var(--size-base) * 60);
  }

  .copyright {
    position: absolute;
    top: unset;
    bottom: 1%;
    left: 0;
    padding-left: 1.7%;
  }
}

[class*="speech_bubble"] {
  position: absolute;
  z-index: var(--z-index-screen);
}

.speech_bubble {
  &7 {
    bottom: 39%;
    right: 5%;
  }
}

.popup-tap_prompt {
  width: calc(var(--size-base) * 900);
  height: calc(var(--size-base) * 312);

  &-finger {
    position: absolute;
    width: calc(var(--size-base) * 100);
    top: 65%;
    left: 63%;
  }
}
</style>